<template>
  <div class="partner-slider slim-slider">
    <Slider v-if="partners && partners.length" classes="size-4">
      <PartnerCard
        v-for="(partner, index) of partners"
        :key="`partner-${index}`"
        slim-slider
        :partner="partner"
      />
    </Slider>
  </div>
</template>

<script>
import Slider from 'Components/Slider.vue';
import PartnerCard from './PartnerCard.vue';

export default {
  name: 'PartnerSlider',
  components: {
    PartnerCard,
    Slider,
  },

  data() {
    return {
      partners: JSON.parse(this.$mountEl.dataset.partners),
    };
  },
};
</script>
